import TestController from '@/controllers/TestController';
import { log, LoggingType } from '@/logging/CustomLogging';
import Utility from '@/util/Utility';
import ITestBeginState from './ITestBeginState';
import TestStartContext from './TestStartContext';
import TestStartDisplayType from './TestStartDisplayType';

class LoadingState implements ITestBeginState {
  private readonly context: TestStartContext;
  private readonly testController: TestController | undefined;
  private readonly jwt: string | undefined;
  constructor(context: TestStartContext, testController: TestController | undefined, jwt: string | undefined) {
    this.context = context;
    this.testController = testController;
    this.jwt = jwt;
  }
  performFunction(): void {
    if (this.testController && this.jwt) {
      const qtiSessionId: string | undefined = Utility.getValueFromJWT(this.jwt, 'qtiSessionId') as string;
      const sessionId: string | undefined = Utility.getValueFromJWT(this.jwt, 'sessionId') as string;
      const formId: string | undefined = Utility.getValueFromJWT(this.jwt, 'formId') as string;
      const backend: string | undefined = Utility.getValueFromJWT(this.jwt, 'backend') as string;
      const testName: string | undefined = Utility.getValueFromJWT(this.jwt, 'testName') as string;
      const previewMode: boolean | undefined = Utility.getValueFromJWT(this.jwt, 'previewMode') as boolean;
      const fromApp: string | undefined = Utility.getValueFromJWT(this.jwt, 'fromApp') as string;

      if (previewMode) {
        this.context.title = 'Test Name (displayed on test)';
      } else if (testName) {
        this.context.title = testName;
      } else {
        this.context.title = ' ';
      }

      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;
      this.testController!.initialize(qtiSessionId, sessionId, formId, backend, previewMode, this.jwt, fromApp)
        .then(() => {
          that.transitionToStart();
          return;
        })
        .catch((error) => {
          log('LoadingState: ' + error, LoggingType.ERROR);
          that.transitionToErrorState();
          return;
        });
    } else {
      this.transitionToErrorState();
    }
  }

  private transitionToStart() {
    this.context.setTestBeginState(TestStartContext.START);
  }

  private transitionToErrorState() {
    this.context.setTestBeginState(TestStartContext.ERROR);
  }

  getView(): TestStartDisplayType {
    return TestStartDisplayType.LOADING;
  }
}

export default LoadingState;
